module.exports = __webpack_public_path__ + "static/media/truck9.73442d46.jpg";